import { render } from "./UserDropDown.vue?vue&type=template&id=03c44588"
import script from "./UserDropDown.vue?vue&type=script&lang=js"
export * from "./UserDropDown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__